import { termsSchema, tncFi } from '@axo/form/feature/terms-and-conditions';
export default termsSchema.parse(tncFi);
